module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"socialMedia":"社交网站"},"zh_hk":{"socialMedia":"社交網站"},"en":{"socialMedia":"Social Media"},"ja":{"socialMedia":"公式SNS"}}')
  delete Component.options._Ctor
}
